"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollectionWriter = void 0;
var form_field_1 = require("../fields/form.field");
var capture_provider_1 = require("../fields/provider/capture.provider");
var collection_model_write_brightnessCorrection_1 = require("./collection.model.write.brightnessCorrection");
var collection_model_write_cropParameter_1 = require("./collection.model.write.cropParameter");
var collection_model_write_drawable_1 = require("./collection.model.write.drawable");
var collection_model_write_field_1 = require("./collection.model.write.field");
var collection_model_write_imageVisibility_1 = require("./collection.model.write.imageVisibility");
var MEASUREMENT_STATE_TYPE = 'truesize';
var IkeModelCollectionWriter = /** @class */ (function () {
    function IkeModelCollectionWriter() {
    }
    IkeModelCollectionWriter.writeField = function (collectionField) {
        return collection_model_write_field_1.FieldWriters[collectionField.schema.type](collectionField);
    };
    IkeModelCollectionWriter.writeData = function (instance) {
        var instanceData = {
            _id: instance.instanceId
        };
        for (var _i = 0, _a = instance.schema.fields; _i < _a.length; _i++) {
            var schemaField = _a[_i];
            if (!instance.hasField(schemaField.id)) {
                continue;
            }
            var field = instance.getField(schemaField.id);
            if (form_field_1.CollectionModelFieldSubForm.isSubFormField(field)) {
                instanceData[schemaField.id] = field.value.map(function (ins) { return IkeModelCollectionWriter.writeData(ins); });
            }
            else if (field.hasValue()) {
                instanceData[schemaField.id] = IkeModelCollectionWriter.writeField(field);
            }
        }
        return instanceData;
    };
    IkeModelCollectionWriter.writeCollectionMeasurements = function (model) {
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (var _i = 0, captures_1 = captures; _i < captures_1.length; _i++) {
            var captureId = captures_1[_i];
            var capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            var state = model.getDrawableState(captureId);
            var _loop_1 = function (drawable) {
                output[captureId] = output[captureId] || { state: [], type: MEASUREMENT_STATE_TYPE, captureId: captureId };
                if (output[captureId].state.find(function (existing) { return existing.id === drawable.id; })) {
                    return "continue";
                }
                var val = collection_model_write_drawable_1.DrawableWriter.write(model, drawable);
                if (val == null) {
                    return "continue";
                }
                output[captureId].state.push(val);
                output[captureId].captureId = captureId;
            };
            for (var _a = 0, _b = state.values(); _a < _b.length; _a++) {
                var drawable = _b[_a];
                _loop_1(drawable);
            }
        }
        return output;
    };
    IkeModelCollectionWriter.writeCollectionBrightnessCorrections = function (model) {
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (var _i = 0, captures_2 = captures; _i < captures_2.length; _i++) {
            var captureId = captures_2[_i];
            var capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            var state = model.getBrightnessCorrectionState(captureId);
            var _loop_2 = function (brightnessCorrection) {
                output[captureId] = output[captureId] || { state: [], type: capture.type, captureId: captureId };
                if (output[captureId].state.find(function (existing) { return existing.id === brightnessCorrection.id; })) {
                    return "continue";
                }
                var val = collection_model_write_brightnessCorrection_1.BrightnessCorrectionWriter.write(brightnessCorrection);
                if (val == null) {
                    return "continue";
                }
                output[captureId].state.push(val);
                output[captureId].captureId = captureId;
            };
            for (var _a = 0, _b = state.values(); _a < _b.length; _a++) {
                var brightnessCorrection = _b[_a];
                _loop_2(brightnessCorrection);
            }
        }
        return output;
    };
    IkeModelCollectionWriter.writeImageVisibilities = function (model) {
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (var _i = 0, captures_3 = captures; _i < captures_3.length; _i++) {
            var captureId = captures_3[_i];
            var capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            var state = model.getImageVisibilityState(captureId);
            if (state.hasImageVisibility()) {
                var imageVisibility = state.getImageVisibility();
                output[captureId] = output[captureId] || { state: undefined, type: capture.type, captureId: captureId };
                output[captureId].state = collection_model_write_imageVisibility_1.ImageVisibilityWriter.write(imageVisibility);
                output[captureId].captureId = captureId;
            }
        }
        return output;
    };
    IkeModelCollectionWriter.writeCollectionCropParameters = function (model) {
        var output = {};
        var captures = capture_provider_1.CaptureProvider.getCaptureIds(model);
        for (var _i = 0, captures_4 = captures; _i < captures_4.length; _i++) {
            var captureId = captures_4[_i];
            var capture = model.state.getCapture(captureId);
            if (capture == null) {
                continue;
            }
            var state = model.getCropParameterState(captureId);
            var _loop_3 = function (cropParameter) {
                output[captureId] = output[captureId] || { state: [], type: capture.type, captureId: captureId };
                if (output[captureId].state.find(function (existing) { return existing.id === cropParameter.id; })) {
                    return "continue";
                }
                var val = collection_model_write_cropParameter_1.CropParameterWriter.write(cropParameter);
                if (val == null) {
                    return "continue";
                }
                output[captureId].state.push(val);
                output[captureId].captureId = captureId;
            };
            for (var _a = 0, _b = state.values(); _a < _b.length; _a++) {
                var cropParameter = _b[_a];
                _loop_3(cropParameter);
            }
        }
        return output;
    };
    return IkeModelCollectionWriter;
}());
exports.IkeModelCollectionWriter = IkeModelCollectionWriter;
//# sourceMappingURL=collection.model.write.js.map